import React from 'react';
import { connect } from 'react-redux';
import { Alert } from 'react-bootstrap';
import AgreementsModal from 'containers/request/Initial/Agreements/AgreementsModal';
import LicenseAgreementContent from 'containers/request/Initial/Agreements/LicenseAgreementContent';
import { WithModal } from 'ctia-ui';
import { downloadAgreementBlank } from 'actions/agreement';

class AgreementPreview extends WithModal {
  onPrintClick = () => {
    this.props.downloadAgreementBlank(this.props.user.company, '');
  };

  render() {
    return (
      <div>
        <Alert bsStyle="warning">
          Click <a onClick={this.handleModal}>here</a> if you would like to
          review the certification license agreement terms and conditions before
          submitting your certification request. You will see the license
          agreement when submitting your request and will be asked to agree to
          its terms and conditions before the device can be certified.
        </Alert>
        <AgreementsModal
          show={this.state.showModal}
          modalHandler={this.handleModal}
          downloadHandler={this.onPrintClick}
          content={LicenseAgreementContent}
        />
      </div>
    );
  }
}

function mapStateToProps({ user }) {
  return { user };
}

export default connect(
  mapStateToProps,
  {
    downloadAgreementBlank
  }
)(AgreementPreview);



// WEBPACK FOOTER //
// ./src/containers/request/AgreementPreview.js